module.exports = __webpack_public_path__ + "static/media/106.1dc90cd8.webp";